(ns app.front.view.wizard.buttons
  (:require [app.front.ui.action-buttons :as ui-action-buttons]
            [core.front.icons :as i]))

(def wizard-button-container :div.bx--row.mt-4>div.bx--col-xs-12.flex.justify-end)

(defn buttons
  "Buttons to be displayed on the bottom of the Creation wizard section."
  [tr {:keys [next back cancel-link]}]
  [wizard-button-container
   [ui-action-buttons/action-buttons {:buttons [{:href      (or cancel-link "#")
                                                 :disabled? (not cancel-link)
                                                 :text      (tr [:cancel])}
                                                (merge
                                                  {:text (tr [:back])}
                                                  back)
                                                (merge
                                                  {:text (tr [:next])
                                                   :icon i/arrow-right
                                                   :id   :create-wizard-next}
                                                  next)]}]])
